module.exports = __webpack_public_path__ + "static/about-us-5dc1a384d615866da528734f476afc24.jpg";